import React from "react"
import { Link, useLocation } from "react-router-dom"
import { FormattedMessage, useIntl } from "react-intl"
import { LOGIN_LANDING } from "constants/paths"
import { useApplicationContext } from "context/applicationContext"
import Icon from "components/Icon/Icon"
import {
	getMenuOptionsForUser,
	MenuOptionData,
	OptionData,
} from "components/Shared/MenuOptions"
import "./Sidebar.scss"

const ROOT_PATH = "/"

const addSelectedClass = (
	currentPath: string,
	basePath: string,
	exact = false
): string => {
	const pathRegex = `^${basePath}${exact ? "$" : ""}`
	const isPathMatch = new RegExp(pathRegex).test(currentPath)
	return isPathMatch ? "menu-option-selected" : ""
}

const addCollapsedClass = (isCollapsed: boolean) => {
	return isCollapsed ? "sidebar-collapsed" : ""
}

const addLandingStyle = (pathName: string) =>
	pathName === ROOT_PATH ? "sidebar-landing" : ""

const Sidebar: React.FC = () => {
	const intl = useIntl()
	const { pathname } = useLocation()
	const { collapseSideBar, setCollapseSideBar } = useApplicationContext()
	const menuOptions = getMenuOptionsForUser(intl)

	const hamburgerMenuCallback = () => {
		collapseSideBar ? setCollapseSideBar(false) : setCollapseSideBar(true)
	}

	return pathname === LOGIN_LANDING ? null : (
		<div
			className={`sidebar ${addLandingStyle(pathname)} ${addCollapsedClass(
				collapseSideBar
			)}`}
		>
			<div
				role="hamburger-menu"
				className="hamburger-menu"
				onClick={() => hamburgerMenuCallback()}
			>
				<div className="hamburger-lines">
					<div className="menu-line" />
					<div className="menu-line" />
					<div className="menu-line" />
				</div>
				<div className="menu-title font-16" role="menu-title">
					<FormattedMessage id="phronesis.menu.title" />
				</div>
			</div>
			{menuOptions.map((option: OptionData) => (
				<MenuOptionLink key={option.id} pathName={pathname} option={option} />
			))}
		</div>
	)
}

const MenuOptionLink: React.FC<MenuOptionData> = ({
	pathName,
	option: { id, to, title, icon },
}) => {
	return (
		<React.Fragment>
			<Link id={`menu-option-${id}`} to={to} title={title}>
				<div className={`menu-option ${addSelectedClass(pathName, to)}`}>
					<Icon icon={icon} className="icon" />
					<div className="title">
						<div className="content">{title}</div>
					</div>
				</div>
			</Link>
		</React.Fragment>
	)
}

export default Sidebar
